import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BiTimeChart } from '@/features/dashboard-finance/charts/BiTimeChart';
import { formatInt, formatYyyymmddDisplay } from '@/features/dashboard-finance/formatters';

/**
 * Novas assinaturas por dia (série já contada por `SalesDashboardPage`). Reutiliza
 * `BiTimeChart`/formatters do dashboard financeiro.
 *
 * Origem: sem issue — commit 8e8dea1c0, 2026-05-04 16:05 +0200; Cloudscape desde a0887214d
 * (39-H).
 * Usado por: `SalesDashboardPage` (rota `/dashboard/sales`, `apps/admin`), único consumidor.
 *
 * Histórico:
 *  - 2026-10-10 14:40 +0200 — (#798) cabeçalho padrão (#796).
 */
export function NewSubscriptionsChart({
  series,
}: {
  series: readonly { yyyymmdd: string; count: number }[];
}): React.JSX.Element {
  const { t } = useTranslation();
  const data = series.map((d) => ({ x: formatYyyymmddDisplay(d.yyyymmdd), y: d.count }));
  return (
    <BiTimeChart
      title={t('sales.charts.newSubscriptions')}
      type="bar"
      data={data}
      color="#10b981"
      valueFormatter={(v): string => formatInt(v)}
    />
  );
}
